<template>
  <ul
    :id="id"
    class="card"
    :draggable="draggable"
    @dragstart="dragStart"
    @dragend="dragEnded"
    @dragover.stop
  >
    <slot />
  </ul>
</template>
<script>
export default {
  props: ["id", "draggable", "box_id"],
  data: function() {
    return {};
  },
  methods: {
    dragStart(e) {
      const target = e.target;
      e.dataTransfer.setData("card_id", target.id);
      e.dataTransfer.setData("box_id", this.$props.box_id);
      setTimeout(() => {
        target.style.display = "none";
      }, 0);
    },
    dragEnded: e => {
      var ele = document.getElementsByClassName("card");
      for (var i = 0; i < ele.length; i++) {
        ele[i].style.display = "flex";
      }
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  align-items: center;
}
.card li {
  width: 33%;
}
.card li:last-of-type {
  text-align: right;
}
</style>
